var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('l-confirm-dialog',_vm._g(_vm._b({attrs:{"title":_vm.$t('exportExpenses'),"content":_vm.$t('exportExpensesPrompt'),"action":_vm.$t('exportNow')},on:{"confirm":_vm.exportExpenses}},'l-confirm-dialog',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }